import { makeStyles, Text } from '@fluentui/react-components';
import { useAutofocus } from '@utils';
import { FreddyWarningGif } from '@utils-global';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'linear-gradient(to bottom right, #091731, #1D305A)',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
  },
  image: {
    width: '55%',
    marginBottom: '16px',
  },
  title: {
    color: '#ffffff',
    textAlign: 'center',
  },
  description: {
    color: '#E0E0E0',
    textAlign: 'center',
    marginTop: '8px',
    padding: '0 24px',
    whiteSpace: 'pre-line',
  },
  warning: {
    color: '#ffffff',
    textAlign: 'center',
    marginTop: '16px',
    padding: '0 24px',
  },
  footer: {
    color: '#E0E0E0',
    textAlign: 'center',
    position: 'absolute',
    bottom: '32px',
  },
});

export const PhishingInteractedResult = () => {
  const styles = useStyles();
  const { targetRef } = useAutofocus();
  const { t } = useTranslation();

  return (
    <section
      tabIndex={-1}
      ref={targetRef}
      className={styles.wrapper}
      aria-label="Report result page"
    >
      <img src={FreddyWarningGif} alt="" className={styles.image} aria-hidden="true" />
      <Text weight="semibold" size={600} className={styles.title} role="heading">
        {t('reportPage.phishing.interacted.title')}
      </Text>
      <Text weight="regular" size={300} className={styles.description}>
        {t('reportPage.phishing.interacted.description')}
      </Text>
      <Text weight="bold" size={300} className={styles.warning}>
        {t('reportPage.phishing.interacted.warning')}
      </Text>
      <Text weight="regular" size={200} className={styles.footer}>
        {t('reportPage.phishing.interacted.footer')}
      </Text>
    </section>
  );
};
